/* qeslint-disable */
// q@ts-nocheck

import * as JQuery from "jquery";
import { Cartesian3, Cartographic, Math as CesiumMath } from "cesium";
import {
    Annotation,
    ConstruktedAnnotationType,
    ConstruktedAnnotationTypes,
    ConstruktedClippingTypes,
    ConstruktedDrawingTypes,
    ConstruktedMeasurementTypes
} from "../types/common";
import { ImagePlane as ImagePlaneDrawing } from "../tools";

export {
    ConstruktedAnnotationTypes,
    ConstruktedDrawingTypes,
    ConstruktedMeasurementTypes,
    type ConstruktedAnnotationType,
    ConstruktedClippingTypes
};

export enum ConstruktedAnnotationCategories {
    Drawing = "drawing",
    Measurement = "measurement",
    Clipping = "clipping"
}

export type AnnotationData = {
    id: string;
    type: ConstruktedAnnotationType;
    title: string;
    details: any; // object
};

export const toggleAnnotationDetailsWindowPosition = (position: string) => {
    const jQuery = window.jQuery;

    // Check if ck-note-details has class floating
    if (position === "floating") {
        jQuery(".ck-note-details").addClass("floating");

        // Predefine some position and size
        const left = 100;
        const top = 100;
        const width = jQuery(window).width() / 2;
        const height = jQuery(window).height() / 1.7;

        // Set the position and size
        jQuery(".ck-note-details").css("left", left).css("top", top).css("width", width).css("height", height);

        // Initialize the draggable and resizable
        jQuery(".ck-note-details").draggable({
            containment: ".project-figure-content",
            handle: ".dragger"
        });

        jQuery(".ck-note-details").resizable({
            containment: ".project-figure-content"
        });
    } else {
        // jQuery(".ck-note-modal").css("left", 0).css("top", 60);
        // Delete all inline styles
        jQuery(".ck-note-details").removeAttr("style");

        // Remove draggable and resizable
        if (jQuery(".ck-note-details").hasClass("ui-draggable")) {
            jQuery(".ck-note-details").draggable("destroy");
        }

        if (jQuery(".ck-note-details").hasClass("ui-resizable")) {
            jQuery(".ck-note-details").resizable("destroy");
        }

        // Remove the floating class
        jQuery(".ck-note-details").removeClass("floating");
    }
};

export const animateAnnotationDetailWindow = (html: string) => {
    let timeout = 10;

    const jQuery = window.jQuery;

    if (jQuery(".ck-note-details").length > 0) {
        timeout = 500;
    }

    jQuery(".ck-note-details").removeClass("shown");
    setTimeout(() => {
        jQuery(".ck-note-details").remove();
        jQuery(".project-figure-content ").append(html);
    }, timeout);

    setTimeout(() => {
        jQuery(".ck-note-details").addClass("shown");
        jQuery(".ck-note-details .icon-close.close-note").on("click", function (this: JQuery) {
            const clicked = jQuery(this);

            clicked.parents(".ck-note-details").removeClass("shown");
            setTimeout(() => {
                clicked.parents(".ck-note-details").remove();
            }, 500);
        });

        const position = jQuery.cookie("ck-modal-position");

        toggleAnnotationDetailsWindowPosition(position);
    }, 600);
};

export function triggerShowingAnnontationsPopup() {
    const jQuery = window.jQuery;

    setTimeout(() => {
        jQuery("#construkted-annontations-popup-btn").trigger("click");
    }, 100);
}

export function generateAttachmentsHTML(annotation: Annotation, withRemove = true) {
    if (annotation && annotation.attachments.length > 0) {
        const output: string[] = [];

        annotation.attachments.forEach((attachment: any, index: number) => {
            output.push(
                `<div class="ck-attachment-line-item make-flex ${
                    withRemove === true ? "attachment-remove" : ""
                }" data-annotation="${
                    attachment.id
                }" data-index="${index}"><a target="_blank" rel="noopener noreferrer" href="${
                    attachment.url
                }"><i class="icon-attach"></i> ${attachment.name}</a>${
                    withRemove === true ? '<i class="icon-close"></i>' : ""
                }</div>`
            );
        });

        return output.join("");
    }

    return "";
}

export function createCancelButton() {
    // Check if already exists
    const existingButton = document.getElementById("cancel-annotation-add");

    if (existingButton) {
        return existingButton;
    }

    const button = document.createElement("button");

    button.className = `cancel-annotation-add annotation-create-action`;
    button.id = "cancel-annotation-add";
    button.innerHTML = '<i class="icon-cancel"></i> Cancel';

    return button;
}

export function createFinishButton() {
    // Check if already exists
    const existingButton = document.getElementById("finish-annotation");

    if (existingButton) {
        return existingButton;
    }

    const button = document.createElement("button");

    button.className = `finish-annotation annotation-create-action`;
    button.id = "finish-annotation";
    button.innerHTML = '<i class="icon-tick"></i> Finish';

    return button;
}

export function deleteFinishCancelButtons() {
    const cancelButton = document.getElementById("cancel-annotation-add");

    if (cancelButton) {
        cancelButton.remove();
    }

    const finishButton = document.getElementById("finish-annotation");

    if (finishButton) {
        finishButton.remove();
    }
}

export function getDrawing() {
    const annotationId = jQuery("#annotation-entity-id").val() as string;

    if (!annotationId) {
        return undefined;
    }

    return window.Construkted.drawingTools.getDrawingById(annotationId);
}

export function getImagePlane() {
    const drawing = getDrawing();

    if (!drawing) {
        return undefined;
    }

    if (drawing instanceof ImagePlaneDrawing) {
        return drawing as ImagePlaneDrawing;
    }

    return undefined;
}

// --- Annotation export helpers (GeoJSON / KML) ---

export function buildGeoJSONGeometryFromAnnotation(annotation: Annotation): any | null {
    const type = annotation.type;

    const toLonLatHeight = (x: number, y: number, z: number): [number, number, number] => {
        const cartesian = new Cartesian3(x, y, z);
        const carto = Cartographic.fromCartesian(cartesian);
        const lon = CesiumMath.toDegrees(carto.longitude);
        const lat = CesiumMath.toDegrees(carto.latitude);
        const h = carto.height;

        return [lon, lat, h];
    };

    if (type === ConstruktedAnnotationTypes.DrawingPin || type === ConstruktedAnnotationTypes.DrawingImagePlane) {
        const details = JSON.parse(annotation.details);

        if (!details || !details.position) {
            console.error("Invalid details for point annotation:", annotation);

            return null;
        }

        const { x, y, z } = details.position;
        const coordinates = toLonLatHeight(x, y, z);

        return {
            type: "Point",
            coordinates: coordinates
        };
    }

    if (
        type === ConstruktedAnnotationTypes.DrawingPolyline ||
        type === ConstruktedAnnotationTypes.MeasurementPolyline
    ) {
        const positions: { x: number; y: number; z: number }[] = JSON.parse(annotation.details);

        if (!Array.isArray(positions) || positions.length === 0) {
            console.error("Invalid details for LineString annotation:", annotation);

            return null;
        }

        const coordinates = positions.map((p) => toLonLatHeight(p.x, p.y, p.z));

        return {
            type: "LineString",
            coordinates: coordinates
        };
    }

    const polygonFromPositionsArray = (positions: { x: number; y: number; z: number }[]) => {
        if (!Array.isArray(positions) || positions.length < 3) {
            console.error("Invalid positions for Polygon annotation:", annotation);

            return null;
        }

        const ring = positions.map((p) => toLonLatHeight(p.x, p.y, p.z));

        if (
            ring.length > 0 &&
            (ring[0][0] !== ring[ring.length - 1][0] ||
                ring[0][1] !== ring[ring.length - 1][1] ||
                ring[0][2] !== ring[ring.length - 1][2])
        ) {
            ring.push(ring[0]);
        }

        return {
            type: "Polygon",
            coordinates: [ring]
        };
    };

    if (type === ConstruktedAnnotationTypes.DrawingPolygon || type === ConstruktedAnnotationTypes.MeasurementArea) {
        const positions: { x: number; y: number; z: number }[] = JSON.parse(annotation.details);

        return polygonFromPositionsArray(positions);
    }

    if (type === ConstruktedAnnotationTypes.MeasurementVolume) {
        const details = JSON.parse(annotation.details);
        const polygonPositions: number[] = details && details.polygonPositions;

        if (!Array.isArray(polygonPositions) || polygonPositions.length < 9) {
            console.error("Invalid polygonPositions for MeasurementVolume annotation:", annotation);

            return null;
        }

        const positions: { x: number; y: number; z: number }[] = [];

        for (let i = 0; i + 2 < polygonPositions.length; i += 3) {
            positions.push({
                x: polygonPositions[i],
                y: polygonPositions[i + 1],
                z: polygonPositions[i + 2]
            });
        }

        return polygonFromPositionsArray(positions);
    }

    if (type === ConstruktedAnnotationTypes.DrawingPaint) {
        const details = JSON.parse(annotation.details);
        const positions: { x: number; y: number; z: number }[] = details && details.positions;

        return polygonFromPositionsArray(positions);
    }

    console.warn("Unsupported annotation type for GeoJSON export:", type, annotation);

    return null;
}

export function buildKmlGeometryFromGeoJSON(geometry: any): string | null {
    if (!geometry || !geometry.type) {
        console.warn("Invalid geometry for KML export:", geometry);

        return null;
    }

    if (geometry.type === "Point") {
        const [lon, lat, height] = geometry.coordinates;

        return `<Point><coordinates>${lon},${lat},${height}</coordinates></Point>`;
    }

    if (geometry.type === "LineString") {
        const coordStrings = geometry.coordinates.map((c: [number, number, number]) => `${c[0]},${c[1]},${c[2]}`);

        return `<LineString><coordinates>${coordStrings.join(" ")}</coordinates></LineString>`;
    }

    if (geometry.type === "Polygon") {
        if (!geometry.coordinates || !geometry.coordinates.length) {
            return null;
        }

        const outerRing = geometry.coordinates[0];
        const coordStrings = outerRing.map((c: [number, number, number]) => `${c[0]},${c[1]},${c[2]}`);

        return `<Polygon><outerBoundaryIs><LinearRing><coordinates>${coordStrings.join(
            " "
        )}</coordinates></LinearRing></outerBoundaryIs></Polygon>`;
    }

    console.warn("Unsupported geometry type for KML export:", geometry.type, geometry);

    return null;
}

export function buildKmlGeometryFromAnnotation(annotation: Annotation): string | null {
    const geometry = buildGeoJSONGeometryFromAnnotation(annotation);

    if (!geometry) {
        return null;
    }

    return buildKmlGeometryFromGeoJSON(geometry);
}

export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

function escapeXml(value: string): string {
    return (value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}

export function exportAnnotationAsGeoJSON(annotation: Annotation): void {
    try {
        const geometry = buildGeoJSONGeometryFromAnnotation(annotation);

        if (!geometry) {
            console.error("Failed to build GeoJSON geometry for annotation:", annotation);

            return;
        }

        const feature = {
            type: "Feature",
            properties: {
                id: annotation.entity_id,
                title: annotation.title,
                description: annotation.description,
                type: annotation.type,
                date: annotation.date
            },
            geometry: geometry
        };

        const geojson = {
            type: "FeatureCollection",
            crs: {
                type: "name",
                properties: { name: "urn:ogc:def:crs:EPSG::4326" }
            },
            features: [feature]
        };

        const blob = new Blob([JSON.stringify(geojson, null, 2)], {
            type: "application/geo+json"
        });

        const rawTitle =
            annotation.title && annotation.title.trim().length > 0 ? annotation.title.trim() : "annotation";
        const safeTitle = rawTitle.replace(/[^a-zA-Z0-9-_]+/g, "_");
        const fileName = `${safeTitle}.geojson`;

        downloadBlob(blob, fileName);
    } catch (error) {
        console.error("Error while exporting annotation as GeoJSON:", error, annotation);
    }
}

export function exportAnnotationAsKML(annotation: Annotation): void {
    try {
        const kmlGeometry = buildKmlGeometryFromAnnotation(annotation);

        if (!kmlGeometry) {
            console.error("Failed to serialize geometry to KML for annotation:", annotation);

            return;
        }

        const name = annotation.title && annotation.title.trim().length > 0 ? annotation.title.trim() : "annotation";
        const description = annotation.description || "";

        const kml = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${escapeXml(name)}</name>
    <Placemark>
      <name>${escapeXml(name)}</name>
      <description>${escapeXml(description)}</description>
      ${kmlGeometry}
    </Placemark>
  </Document>
</kml>`;

        const blob = new Blob([kml], { type: "application/vnd.google-earth.kml+xml" });
        const safeTitle = name.replace(/[^a-zA-Z0-9-_]+/g, "_");
        const fileName = `${safeTitle}.kml`;

        downloadBlob(blob, fileName);
    } catch (error) {
        console.error("Error while exporting annotation as KML:", error, annotation);
    }
}

export function exportAllAnnotationsAsGeoJSON(annotations: Annotation[]): void {
    try {
        const features: any[] = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const annotation of annotations) {
            const geometry = buildGeoJSONGeometryFromAnnotation(annotation);

            if (!geometry) {
                continue;
            }

            features.push({
                type: "Feature",
                properties: {
                    id: annotation.entity_id,
                    title: annotation.title,
                    description: annotation.description,
                    type: annotation.type,
                    date: annotation.date
                },
                geometry: geometry
            });
        }

        const geojson = {
            type: "FeatureCollection",
            crs: {
                type: "name",
                properties: { name: "urn:ogc:def:crs:EPSG::4326" }
            },
            features: features
        };
        const blob = new Blob([JSON.stringify(geojson, null, 2)], {
            type: "application/geo+json"
        });

        downloadBlob(blob, "annotations.geojson");
    } catch (error) {
        console.error("Error exporting all annotations as GeoJSON:", error);
    }
}

export function exportAllAnnotationsAsKML(annotations: Annotation[]): void {
    try {
        const placemarks: string[] = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const annotation of annotations) {
            const kmlGeometry = buildKmlGeometryFromAnnotation(annotation);

            if (!kmlGeometry) {
                continue;
            }

            const name = annotation.title?.trim() || "annotation";
            const description = annotation.description || "";

            placemarks.push(`    <Placemark>
      <name>${escapeXml(name)}</name>
      <description>${escapeXml(description)}</description>
      ${kmlGeometry}
    </Placemark>`);
        }

        const kml = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>Annotations</name>
${placemarks.join("\n")}
  </Document>
</kml>`;

        const blob = new Blob([kml], { type: "application/vnd.google-earth.kml+xml" });

        downloadBlob(blob, "annotations.kml");
    } catch (error) {
        console.error("Error exporting all annotations as KML:", error);
    }
}
